module.exports = __webpack_public_path__ + "static/media/content-copy.a1da5fa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/svg/content-copy.svg
// module id = 1585
// module chunks = 0